// extracted by mini-css-extract-plugin
export default {"wrapper":"ThemeToggle_wrapper__uDYHk","toggle":"ThemeToggle_toggle__gi+D9","icon":"ThemeToggle_icon__Vzhh4"};